module.exports = __webpack_public_path__ + "img/zxfw.99a30261.png";